import { createGlobalStyle } from 'styled-components';

export const theme = {
  colors: {
    header: '#9696C0',
    white: '#FFFFFF',
    secondaryText: '#171717B2',
    line: '#17171726',
    lightPurple: '#A39EBF',
    lightPurpleOpacity: '#A39EBF0A',
    blue: '#5278F7',
    green: '#557552',
    greenLight: '#A1BF9E',
    primaryText: '#171717',
    grey: '#53555F',
    purple: '#E9E9F8',
    greenHeader: '#DDF5DB',
    purpleHeader: '#ECECFF',
    orangeHeader: '#FFE8D8',
  },
  content: {
    max_width: '1440px',
  },
  spacings: {
    s2: '2px',
    s4: '4px',
    s8: '8px',
    s12: '12px',
    s16: '16px',
    s20: '20px',
    s24: '24px',
    s32: '32px',
    s40: '40px',
    s48: '48px',
    s56: '56px',
    s64: '64px',
  },
};

export default createGlobalStyle`

@font-face {
  font-family: 'Montserrat';
  src: local('Montserrat Regular'), local('Montserrat-Regular'), url(${require('../src/fonts/Montserrat-Regular.ttf')});
  font-weight: 400;
  font-style: normal;
} 


@font-face {
  font-family: 'Montserrat';
  src: local('Montserrat Medium'), local('Montserrat-Medium'), url(${require('../src/fonts/Montserrat-Medium.ttf')});
  font-weight: 500;
  font-style: normal;
} 

  html {
      min-height: 100vh;
      min-width: 100vw;
  }
  * {
    margin: 0;
      font-family: 'Montserrat', 'Montserrat-Medium',-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    font-weight: 400;
    text-align: left;
    
    * {
      padding: 0;
      margin: 0;
      border: 0;
    }


    *,
    *::before,
    *::after {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }

    :focus, :active {
      outline: none;
    }
    
    a:focus, a:active {
      outline: none;
    }

    nav, footer, header, aside {
      display: block;
    }

    html, body {
      margin: 0;
      height: 100%;
      width: 100%;
      line-height: 1;
      font-size: 14px;
      -ms-text-size-adjust: 100%;
      -webkit-text-size-adjust: 100%;
      background-color: ${theme.colors.white};
    }

    input, button, textarea {
      font-family: inherit;
    }

    input::-ms-clear {
      display: none;
    }

    button {
      cursor: pointer;
    }

    a, a:visited {
      text-decoration: none;
    }

    a:hover {
      text-decoration: none;
    }

    ul li {
      list-style: none;
    }

    img {
      vertical-align: top;
    }

    * {
      font-family: 'Montserrat', 'Montserrat-Medium', 'Roboto', sans-serif;
    }

    h4, h5, h6 {
      font-size: inherit;
      font-weight: 400;
    }
  }

  html {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
`;
